
import { NavLink, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from "@/components/ui/sidebar";
import { BarChart3, Database, Mail, Settings, Brain } from "lucide-react";

interface WorkspaceSidebarProps {
  currentWorkspace: "data" | "email" | "analytics";
}

const WorkspaceSidebar = ({ currentWorkspace }: WorkspaceSidebarProps) => {
  const sidebar = useSidebar();
  const location = useLocation();
  
  const workspaces = [
    { title: "Analytics Hub", url: "/analytics", icon: BarChart3, key: "analytics" },
    { title: "Data Workspace", url: "/data", icon: Database, key: "data" },
    { title: "Email Workspace", url: "/email", icon: Mail, key: "email" },
  ];

  const settings = [
    { title: "AI Context", url: "/ai-context", icon: Brain },
    { title: "Settings", url: "/settings", icon: Settings },
  ];
  
  const currentPath = location.pathname;
  
  const getNavClass = ({ isActive }: { isActive: boolean }) => 
    `flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-all ${
      isActive 
        ? "bg-accent text-accent-foreground font-medium" 
        : "text-muted-foreground hover:bg-accent/50 hover:text-accent-foreground"
    }`;

  return (
    <Sidebar
      className={`border-r ${sidebar.state === "collapsed" ? "w-14" : "w-56"}`}
      collapsible="icon"
    >
      <SidebarContent>
        <div className="flex h-14 items-center border-b px-3">
          {sidebar.state !== "collapsed" && (
            <span className="font-semibold">ScoutLink.ai</span>
          )}
          <SidebarTrigger className={`ml-auto ${sidebar.state === "collapsed" ? "rotate-180" : ""}`} />
        </div>
        
        <SidebarGroup>
          <SidebarGroupLabel>Workspaces</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {workspaces.map((workspace) => (
                <SidebarMenuItem key={workspace.title}>
                  <SidebarMenuButton asChild>
                    <NavLink to={workspace.url} className={getNavClass}>
                      <workspace.icon className="h-4 w-4" />
                      {sidebar.state !== "collapsed" && <span>{workspace.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        <SidebarGroup>
          <SidebarGroupLabel>Configuration</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {settings.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink to={item.url} className={getNavClass}>
                      <item.icon className="h-4 w-4" />
                      {sidebar.state !== "collapsed" && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};

export default WorkspaceSidebar;
